<template>
  <div>
    <div class="sparkle-in-modal" v-if="itemsWithClosenessQualifiers > 0">
      <div class="mr-3">
        <div class="sparkle__icon"></div>
      </div>
      <div class="sparkle__text">
        <div
          class="sparkle__title"
        >You have {{itemsWithClosenessQualifiers}} {{itemsWithClosenessQualifiers | pluralize('item')}} in your cart that {{itemsWithClosenessQualifiers == 1 ? 'qualifies' : 'qualify'}} for an offer!</div>
        <div
          class="sparkle__description"
        >Complete {{itemsWithClosenessQualifiers | pluralize('offer')}} to save more!</div>
      </div>
    </div>

    <div class="panel" v-show="itemsWithClosenessQualifiers">
      <template v-for="(category, categoryIndex) in cartItems">
        <template v-if="category.items.length > 0">
          <cart-item
            v-for="(item, itemIndex) in category.items"
            v-bind:cartItem="item"
            v-bind:categoryIndex="categoryIndex"
            v-bind:itemIndex="itemIndex"
            listname='Items in this offer'
            :position="itemIndex+1"
            v-bind:options="{
                            
                            displayType: 'cart',
                            disableLinks: true
                            }"
            v-bind:key="item.id"
            v-if="item.availableCoupons.length > 0 || item.availablePromotions.length"
          ></cart-item>
        </template>
      </template>
    </div>

    <div class="sparkle-completed"  v-show="itemsWithClosenessQualifiers === 0">
      You have completed all offers.
    </div>
  </div>
</template>

<script>
import CartItem from "./CartItem";

export default {
  name: "ModalSparkle",
  components: {
    "cart-item": CartItem
  },
  props: {
    parentModalRef: {
      type: String
    }
  },
  data() {
    return {};
  },
  computed: {
    cartItems() {
      return this.$store.state.cart.commerceItems;
    },
    itemsWithClosenessQualifiers: function() {
      var itemCountWithClosenessQualifier = 0;

      // Search through each category for items that have a closenessQualifier
      this.cartItems.forEach(function(category) {
        category.items.forEach(function(item) {
          if (item.availableCoupons.length > 0) {
            itemCountWithClosenessQualifier++;
          }

          if (item.availablePromotions.length > 0) {
            itemCountWithClosenessQualifier++;
          }
        });
      });

      return itemCountWithClosenessQualifier;
    }
  },
  mounted (){
      if(this.itemsWithClosenessQualifiers === 0){
        // Nothing to do, goodbye

        var vm = this
        setTimeout(function(){ 
          vm.$root.$emit("bv::hide::modal", vm.parentModalRef);
        }, 1000);
      }
  },
  watch: {
    // Destroy myself if there is nothing to be done.
    itemsWithClosenessQualifiers (newValue, oldValue) {
      if (newValue <= 0) {
        this.$root.$emit("bv::hide::modal", this.parentModalRef);
      }
    }
  }
};
</script>

<style scoped>
  .sparkle-completed{
    text-align: center;
  }
</style>